/* sola-pdp-zoom.js — contained pinch-zoom for the PDP main image (touch only).
 * Pinch zooms the image INSIDE .sola-pdp__stage (overflow:hidden clips it) instead of
 * zooming the page; one finger pans while zoomed; releasing near 1x snaps back;
 * double-tap toggles 2.5x at the tap point. Zoom resets when the main image swaps
 * (thumbnail tap / variant change). Mouse/desktop behavior is untouched.
 */
(function () {
  if (window.__solaPdpZoom) return; window.__solaPdpZoom = true;

  var MAX_SCALE = 4;
  var SNAP_BELOW = 1.15;
  var DBLTAP_SCALE = 2.5;
  var DBLTAP_MS = 300;

  function init() {
    var stage = document.querySelector('.sola-pdp__stage');
    var img = document.getElementById('sola-pdp-main');
    if (!stage || !img) return;

    // Vertical page scroll keeps working on the stage; browser pinch-zoom on it is ours.
    stage.style.touchAction = 'pan-y';

    var s = 1, tx = 0, ty = 0;          // current transform
    var pointers = new Map();            // active touch pointers
    var pinch0 = null;                   // {dist, s, tx, ty, mx, my} at pinch start
    var pan0 = null;                     // {x, y, tx, ty} at single-finger pan start
    var lastTap = 0;
    var zoomedOnce = false;

    function apply(animate) {
      img.style.transition = animate ? 'transform .18s ease-out' : 'none';
      img.style.transform = s === 1 && !tx && !ty ? '' : 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
      img.style.willChange = s > 1 ? 'transform' : '';
      // While zoomed, own ALL touches on the stage (pan the image, not the page).
      stage.style.touchAction = s > 1 ? 'none' : 'pan-y';
    }
    function clampT() {
      var r = stage.getBoundingClientRect();
      var maxX = (s - 1) * r.width / 2, maxY = (s - 1) * r.height / 2;
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    }
    function reset(animate) { s = 1; tx = 0; ty = 0; pinch0 = pan0 = null; apply(animate); }

    function mid(a, b, r) { return { x: (a.x + b.x) / 2 - r.left - r.width / 2, y: (a.y + b.y) / 2 - r.top - r.height / 2 }; }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var pts = Array.from(pointers.values());
      if (pts.length === 2) {
        var r = stage.getBoundingClientRect();
        var m = mid(pts[0], pts[1], r);
        pinch0 = { dist: dist(pts[0], pts[1]), s: s, tx: tx, ty: ty, mx: m.x, my: m.y };
        pan0 = null;
        if (!zoomedOnce) { zoomedOnce = true; if (window.posthog && posthog.capture) posthog.capture('pdp_image_zoom'); }
      } else if (pts.length === 1) {
        if (s > 1) pan0 = { x: pts[0].x, y: pts[0].y, tx: tx, ty: ty };
        // double-tap toggle
        var now = Date.now();
        if (now - lastTap < DBLTAP_MS) {
          var r2 = stage.getBoundingClientRect();
          if (s > 1) reset(true);
          else {
            var px = e.clientX - r2.left - r2.width / 2, py = e.clientY - r2.top - r2.height / 2;
            s = DBLTAP_SCALE; tx = -px * (DBLTAP_SCALE - 1); ty = -py * (DBLTAP_SCALE - 1);
            clampT(); apply(true);
          }
          lastTap = 0;
        } else lastTap = now;
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'touch' || !pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var pts = Array.from(pointers.values());
      if (pinch0 && pts.length >= 2) {
        var r = stage.getBoundingClientRect();
        var d = dist(pts[0], pts[1]);
        var m = mid(pts[0], pts[1], r);
        var ns = Math.min(MAX_SCALE, Math.max(1, pinch0.s * (d / (pinch0.dist || 1))));
        // keep the image point that was under the pinch midpoint anchored to it
        var qx = (pinch0.mx - pinch0.tx) / pinch0.s, qy = (pinch0.my - pinch0.ty) / pinch0.s;
        s = ns; tx = m.x - qx * ns; ty = m.y - qy * ns;
        clampT(); apply(false);
        e.preventDefault();
      } else if (pan0 && s > 1 && pts.length === 1) {
        tx = pan0.tx + (pts[0].x - pan0.x);
        ty = pan0.ty + (pts[0].y - pan0.y);
        clampT(); apply(false);
        e.preventDefault();
      }
    }, { passive: false });

    function release(e) {
      if (e.pointerType !== 'touch') return;
      pointers.delete(e.pointerId);
      var left = pointers.size;
      if (left < 2) pinch0 = null;
      if (left === 1 && s > 1) {
        var p = Array.from(pointers.values())[0];
        pan0 = { x: p.x, y: p.y, tx: tx, ty: ty };
      } else pan0 = null;
      if (left === 0 && s < SNAP_BELOW) reset(true);
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    // Swapping to another photo (thumb tap / variant change) starts fresh.
    new MutationObserver(function () { reset(false); }).observe(img, { attributes: true, attributeFilter: ['src'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
